import {LangUtil} from '../lang-util'

export const reportEn = {
  sendToMail: 'Send report to email',
  sendTurnedOn: 'Enabled',
  send: 'Send',
  addEmail: 'Add new email',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  yearly: 'Yearly',
  day: 'Day',
  time: 'Time',
  startDate: 'Start date',
  eachDay1: 'Each',
  eachDay2: 'day',
  eachWeek1: 'Each',
  eachWeek2: 'week',
  eachMonth1: 'Each',
  eachMonth2: 'month',
  eachYear1: 'Each',
  eachYear2: 'year',
  onDayOfMonth: 'On day of month',
  onDaySelected: 'On day selected',
  selectedDayNumber: (num: string, _gender: 0 | 1 | 2): string => {
    switch (num) {
      case '1':
        return 'first'
      case '2':
        return 'second'
      case '3':
        return 'third'
      case '4':
        return 'fourth'
      case '5':
        return 'fifth'
      case 'last':
        return 'last'
      default:
        throw new Error(`Day number is not supported: ${num}`)
    }
  },
  selectedDayType: (t: string): string => {
    switch (t) {
      case '0':
        return 'Monday'
      case '1':
        return 'Tuesday'
      case '2':
        return 'WednesDay'
      case '3':
        return 'Thursday'
      case '4':
        return 'Friday'
      case '5':
        return 'Saturday'
      case '6':
        return 'Sunday'
      case 'day':
      case 'weekday':
      case 'weekend':
        return t
      default:
        throw new Error(`Day type is not supported: ${t}`)
    }
  },
  emailTitle: 'Regular report',
  emailText: (
    name: string,
    date: string,
    email: string,
    reportId: string,
    companyId: string,
    baseUrl: string
  ) =>
    LangUtil.stripMargin(
      `
      Regular report "${name}" of ${date} is in the attachments


      To unsubscribe from the report, follow the link:
      ${baseUrl}/data/reports/report-unsubscribe?email=${email}&reportId=${reportId}&companyId=${companyId}

      --
      YouGile Team,
      ${baseUrl}
      `
    ),
  emailTextHtml: (
    name: string,
    date: string,
    email: string,
    reportId: string,
    companyId: string,
    baseUrl: string
  ) =>
    `
    <p>Regular report "<strong>${name}</strong>" of ${date} is in the attachments</p>
    <br>
    <br>
    <p>To unsubscribe from the report, <a href="${baseUrl}/data/reports/report-unsubscribe?email=${email}&reportId=${reportId}&companyId=${companyId}">follow the link</a></p>
    <br>
    <hr>
    <p>YouGile Team,<br>
    <a href="${baseUrl}">${baseUrl}</a></p>
    `,
  showTimeline: 'Show timeline',
  showTable: 'Show table',
  moveDates: 'relative dates',
  moveDatesHint:
    'Dates are relative to current date and tomorrow they will be shifted by one day',
  availableFor: 'Available for users',
  availableForTitle: 'Report visibility',
  availableForHelp:
    'These users can see this report but can’t see tasks in ' +
    'this report that are not available for them. You can choose ' +
    'administrators and managers of a department here',
  reportName: 'Report name',
  openTasks: 'Open tasks',
  completedTasks: 'Completed tasks',
  addReport: 'Add report',
  back: 'Back to all reports',
  editReportDisallowed: 'You can’t edit this report',
  tableTitle: 'Table columns',
  tableAvailable: 'Available columns',
  tableCurrent: 'Chosen columns',
  tableAdd: 'Add to table',
  tableRemove: 'Remove from table',
  tableUp: 'Move up (column order)',
  tableDown: 'Move down (column order)',
  report: 'Main',
  tables: 'Reports',
  groupType: 'Report type',
  groupUser: 'By user',
  groupDepartment: 'By department',
  groupProject: 'By project',
  groupTitle: {
    user: 'Assigned user',
    department: 'Department',
    project: 'Project'
  },
  addColumn: 'Add column',
  columnEditTitle: 'Setup column',
  deleteColumn: 'Delete column',
  columnName: 'Column title',
  namePlaceHolder: 'Enter title',
  exampleNew30d: 'Created in last 30 days',
  exampleCompleted30d: 'Completed in last 30 days',
  exampleByProjects: 'By projects',
  exampleWithChats: 'With active chats',
  yourReports: 'Your reports',
  totalTasksNum: 'Задач в отчёте',
  openTasksNum: 'Открытых',
  completedTasksNum: 'Завершённых',

  locationStatusGroup: 'Location / Status',
  datesGroup: 'Dates',
  usersGroup: 'Users',
  stickersGroup: 'Stickers',
  miscGroup: 'Misc.',
  subtasks: 'Subtasks',
  removeAllTasks:
    '[WARNING] This will delete all tasks in this dashboard. Continue?',
  assignedUsers: 'Assigned to tasks',
  clearAllFilters: 'Clear all filters',
  designatedEmployees: 'Назначенные сотрудники',
  location: 'Columns',
  completeness: 'Completeness',
  archival: 'Archival',
  byTimeFilterTitle: 'Project / Board',
  additionalFiltering: 'Additional filtering',
  display: 'Display',
  nothingIsFound: 'Nothing found!',
  emptyBoard: 'There are no tasks on the selected board!',
  tryReset: 'Try canceling some filters or resetting everything.',
  columnNumbers: (amount: number) => `${amount} column${amount > 1 ? 's' : ''}`,
  completed: 'Completed',
  notCompleted: 'Not completed',
  archived: 'Archived',
  notArchived: 'Not archived',
  includingNotSetUsers: 'including unassigned'
}

export const reportRu: typeof reportEn = {
  sendToMail: 'Отправка отчёта на почту',
  sendTurnedOn: 'Включить',
  send: 'Отправлять',
  addEmail: 'Добавить ещё email',
  daily: 'Ежедневно',
  weekly: 'Еженедельно',
  monthly: 'Ежемесячно',
  yearly: 'Ежегодно',
  day: 'День',
  time: 'Время',
  startDate: 'Дата начала повторений',
  eachDay1: 'Каждый',
  eachDay2: 'день',
  eachWeek1: 'Каждую',
  eachWeek2: 'неделю по:',
  eachMonth1: 'Каждый',
  eachMonth2: 'месяц',
  eachYear1: 'Каждый',
  eachYear2: 'год',
  onDayOfMonth: 'В указанный день месяца',
  onDaySelected: 'В выбранный день',
  selectedDayNumber: (num: string, gender: 0 | 1 | 2): string => {
    switch (num) {
      case '1':
        return ['первый', 'первая', 'первое'][gender] || ''
      case '2':
        return ['второй', 'вторая', 'второе'][gender] || ''
      case '3':
        return ['третий', 'третья', 'третье'][gender] || ''
      case '4':
        return ['четвертый', 'четвертая', 'четвертое'][gender] || ''
      case '5':
        return ['пятый', 'пятая', 'пятое'][gender] || ''
      case 'last':
        return ['последний', 'последняя', 'последнее'][gender] || ''
      default:
        throw new Error(`Day number is not supported: ${num}`)
    }
  },
  selectedDayType: (t: string): string => {
    switch (t) {
      case '0':
        return 'понедельник'
      case '1':
        return 'вторник'
      case '2':
        return 'среда'
      case '3':
        return 'четверг'
      case '4':
        return 'пятница'
      case '5':
        return 'суббота'
      case '6':
        return 'воскресенье'
      case 'day':
        return 'день'
      case 'weekday':
        return 'будний день'
      case 'weekend':
        return 'выходной день'
      default:
        throw new Error(`Day type is not supported: ${t}`)
    }
  },
  emailTitle: 'Регулярный отчёт',
  emailText: (
    name: string,
    date: string,
    email: string,
    reportId: string,
    companyId: string,
    baseUrl: string
  ) =>
    LangUtil.stripMargin(
      `
      Отчёт "${name}" от ${date} во вложении. 
      
      
      Чтобы отписаться от отчёта, перейдите по ссылке:
      ${baseUrl}/data/reports/report-unsubscribe?email=${email}&reportId=${reportId}&companyId=${companyId}

      --
      YouGile Team,
      ${baseUrl}
      `
    ),
  emailTextHtml: (
    name: string,
    date: string,
    email: string,
    reportId: string,
    companyId: string,
    baseUrl: string
  ) =>
    `
    <p>Отчёт "<strong>${name}</strong>" от ${date} во вложении.</p>
    <br>
    <br>
    <p>Чтобы отписаться от отчёта, <a href="${baseUrl}/data/reports/report-unsubscribe?email=${email}&reportId=${reportId}&companyId=${companyId}">перейдите по ссылке</a></p>
    <br>
    <hr>
    <p>YouGile Team,<br>
    <a href="${baseUrl}">${baseUrl}</a></p>
    `,
  showTimeline: 'Показать Гант',
  showTable: 'Показать таблицу',
  moveDates: 'сдвигать даты',
  moveDatesHint:
    'Даты будут отсчитываться относительно текущего дня, и завтра они будут смещены на один день вперёд',
  availableForTitle: 'Доступ к отчёту',
  availableFor: 'Отчёт доступен пользователям',
  availableForHelp:
    'Пользователям будет доступен этот отчёт, но они будут видеть в нём ' +
    'только те задачи, к которым у них есть доступ. Можно предоставить ' +
    'доступ администраторам и руководителям отделов',
  reportName: 'Название отчёта',
  openTasks: 'Открытых задач',
  completedTasks: 'Выполненных задач',
  addReport: 'Добавить отчёт',
  back: 'Вернуться к списку отчётов',
  editReportDisallowed: 'У вас недостаточно прав для изменения этого отчёта',
  tableTitle: 'Состав колонок таблицы',
  tableAvailable: 'Доступные колонки',
  tableCurrent: 'Текущий состав таблицы',
  tableAdd: 'Добавить в таблицу',
  tableRemove: 'Убрать из таблицы',
  tableUp: 'Переместить вверх (порядок колонок)',
  tableDown: 'Переместить вниз (порядок колонок)',
  report: 'Общий',
  tables: 'Таблицы',
  groupType: 'Вид отчёта',
  groupUser: 'По людям',
  groupDepartment: 'По отделам',
  groupProject: 'По проектам',
  groupTitle: {
    user: 'Исполнитель задачи',
    department: 'Отдел',
    project: 'Проект'
  },
  addColumn: 'Добавить колонку',
  columnEditTitle: 'Настроить колонку',
  deleteColumn: 'Удалить колонку',
  columnName: 'Название колонки',
  namePlaceHolder: 'Введите название',
  exampleNew30d: 'Новые за 30 дней',
  exampleCompleted30d: 'Выполненные за 30 дней',
  exampleByProjects: 'По проектам',
  exampleWithChats: 'С активным общением',
  yourReports: 'Ваши отчёты',
  totalTasksNum: 'Задач в отчёте',
  openTasksNum: 'Открытых',
  completedTasksNum: 'Завершённых',

  locationStatusGroup: 'Расположение / Статус',
  datesGroup: 'Даты',
  usersGroup: 'Пользователи',
  stickersGroup: 'Стикеры',
  miscGroup: 'Разное',
  subtasks: 'Подзадачи',
  removeAllTasks:
    '[Внимание] Будут удалены все задачи в этой сводке. Продолжить?',
  assignedUsers: 'Исполнители задач',
  clearAllFilters: 'Сбросить все фильтры',
  designatedEmployees: 'Назначенные сотрудники',
  location: 'Колонки',
  completeness: 'Выполненность',
  archival: 'Архивность',
  byTimeFilterTitle: 'Проект / Доска',
  additionalFiltering: 'Дополнительная фильтрация',
  display: 'Отображать',
  nothingIsFound: 'Ничего не найдено!',
  emptyBoard: 'На выбранной доске нет задач!',
  tryReset: 'Попробуйте отменить некоторые фильтры или сбросить всё.',
  completed: 'Выполненные',
  columnNumbers: (amount: number) => {
    const fraction = Number((amount / 10).toString().split('.')[1])
    return `${amount} колон${fraction > 4 ? 'ок' : 'ки'}`
  },
  notCompleted: 'Невыполненные',
  archived: 'Архивированные',
  notArchived: 'Неархивированные',
  includingNotSetUsers: 'включая неназначенных'
}
